import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CButton,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-js-pagination";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { useReactToPrint } from "react-to-print";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";
import authInstance from "src/api/apiConfig";
const BranchReports = () => {
  const componentPDF = useRef();
  const [printState, setPrintState] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [Dealers, setDealers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const SchemaName = sessionStorage.getItem("schemaName");
  const download_btn = () => {
    setPrintState(true);
  };
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const fetchAllDealers = async () => {
    const obj = {
      schemaName: SchemaName,
    };

    try {
      const response = await authInstance.post("getAllBranches", obj);
      if (response?.status === 201) {
        setDealers(response?.data?.data);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    fetchAllDealers();
  }, []);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Dealers?.slice(indexOfFirstRow, indexOfLastRow);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const csvRows = currentRows?.map((item) => ({
    "Branch Name": item.branchName || "--",
    "Branch Code": item.branchCode || "--",
    "Contact Number": item.contactNumber || "--",
    Email: item.email || "--",
    Address: item.address || "--",
  }));
  return (
    <div className="content">
      <CCard className="mb-4">
        <CCardHeader>
          <strong>Branch Report</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol xs={12}>
              <CCard>
                <div className="search_bar">
                  <div className="search-inner">{/* div1 */}</div>
                  {/* btn */}
                  <div className="btn_add mt-0 mb-14">
                    {showAddButton && (
                      <Button
                        className="add-btn w-auto mr-10"
                        onClick={download_btn}
                      >
                        Download
                      </Button>
                    )}
                    {showAddButton && (
                      <CSVLink data={csvRows} filename={"branch-details.csv"}>
                        <CButton className="add-btn w-auto m-0">CSV</CButton>
                      </CSVLink>
                    )}
                  </div>
                </div>
                <CCardBody>
                  <div className="table-container">
                    <div
                      ref={printState ? componentPDF : null}
                      style={{ padding: printState ? "20px" : "0px" }}
                    >
                      {printState && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            background:
                              "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                            padding: "20px",
                          }}
                        >
                          <img
                            src={COMPANY_AddLogo}
                            alt="Logo"
                            width="50px"
                            height="50px"
                          />
                          <p style={{ color: "#FFF" }}>branch List</p>
                          <div style={{ textAlign: "start" }}>
                            <p
                              style={{
                                fontWeight: "bold",
                                color: "#FFF",
                                fontSize: "20px",
                              }}
                            >
                              {COMPANY_NAME}
                            </p>
                            <p
                              style={{ color: "#FFF" }}
                            >{`(${COMPANY_Address})`}</p>
                          </div>
                        </div>
                      )}

                      <CTable color="dark" hover responsive>
                        <CTableHead className="tabl-head">
                          <CTableRow className="table-row">
                            <CTableHeaderCell className="col-1">
                              S. No.
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-2">
                              Branch Name
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-2">
                              Branch Code
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-2">
                              Contact Number
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-2">
                              Email
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-4">
                              Branch Address
                            </CTableHeaderCell>
                            <CTableHeaderCell className="col-2">
                              Actions
                            </CTableHeaderCell>
                          </CTableRow>
                        </CTableHead>
                        <CTableBody>
                          {Dealers && Dealers?.length > 0 ? (
                            currentRows?.map((items, index) => {
                              return (
                                <CTableRow key={index}>
                                  <CTableDataCell>
                                    {indexOfFirstRow + index + 1}
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    {items.branchName ?? "--"}
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    {items.branchCode ?? "--"}
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    {items.contactNumber ?? "--"}
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <div
                                      style={{
                                        maxWidth: "150px", // Adjust max width as needed
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={items.email} // Full content shown on hover
                                    >
                                      {items.email ? items.email : "--"}
                                    </div>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <div
                                      style={{
                                        maxWidth: "150px", // Adjust max width as needed
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={items.address} // Full content shown on hover
                                    >
                                      {items.address ? items.address : "--"}
                                    </div>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <div className="d-flex">
                                      <CButton>Add</CButton>
                                    </div>
                                  </CTableDataCell>
                                </CTableRow>
                              );
                            })
                          ) : (
                            <CTableRow>
                              <CTableDataCell colSpan="6">
                                Loading...
                              </CTableDataCell>
                            </CTableRow>
                          )}
                        </CTableBody>
                      </CTable>
                    </div>

                    {/* <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                > */}
                    <div className="pagin-div">
                      <div>
                        Showing {indexOfFirstRow + 1} to{" "}
                        {Math?.min(indexOfLastRow, Dealers?.length)} of{" "}
                        {Dealers?.length} entries
                      </div>
                      <div className="pagination-container">
                        <ReactPaginate
                          activePage={currentPage}
                          itemsCountPerPage={rowsPerPage}
                          totalItemsCount={
                            Dealers?.length
                            // ? Dealers?.data?.length
                            // : 0
                          }
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          innerClass="pagination"
                          itemClass="page-item"
                          linkClass="page-link"
                        />
                      </div>
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default BranchReports;
